"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadArticlesOfAssociationKycDocumentOptions = void 0;
class UploadArticlesOfAssociationKycDocumentOptions {
    userId;
    files;
}
exports.UploadArticlesOfAssociationKycDocumentOptions = UploadArticlesOfAssociationKycDocumentOptions;
//# sourceMappingURL=UploadArticlesOfAssociationKycDocumentOptions.js.map